import { cva, type VariantProps } from "class-variance-authority";

export { default as Alert } from "./Alert.vue";
export { default as AlertDescription } from "./AlertDescription.vue";
export { default as AlertTitle } from "./AlertTitle.vue";

export const alertVariants = cva(
  "relative w-full rounded-lg px-4 py-3 text-sm grid has-[>svg]:grid-cols-[calc(var(--spacing)*4)_1fr] grid-cols-[0_1fr] has-[>svg]:gap-x-3 gap-y-0.5 items-start [&>svg]:size-4 [&>svg]:translate-y-0.5 [&>svg]:text-current",
  {
    variants: {
      variant: {
        default:
          "text-light-blue-content bg-light-blue [&>svg]:text-current *:data-[slot=alert-description]:text-light-blue-content",
        information:
          "text-information-content bg-information [&>svg]:text-current *:data-[slot=alert-description]:text-information-content",
        success:
          "text-success-content bg-success [&>svg]:text-current *:data-[slot=alert-description]:text-success-content",
        danger:
          "text-danger-content bg-danger [&>svg]:text-current *:data-[slot=alert-description]:text-danger-content",
        warning:
          "text-warning-content bg-warning [&>svg]:text-current *:data-[slot=alert-description]:text-warning-content",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  },
);

export type AlertVariants = VariantProps<typeof alertVariants>;
